import React from 'react'
import { useTable, useSortBy, usePagination } from 'react-table'

export default function Table(props) {
    const queryParams = new URLSearchParams(window.location.search);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
    } = useTable({
        columns: props.columns,
        data: props.data,
        manualSortBy: true,
        manualPagination: true,
    }, useSortBy, usePagination);

    const sortedDesc = <span className="database-table__desc"></span>;
    const sortedAsc = <span className="database-table__asc"></span>;
    const sortedOff = <span className="database-table__asc" style={{opacity: 0}}></span>;

    const getPagination = function() {
        const showPages = 5;
        const eitherSide = 2;
        let finish = props.total;
        let start = queryParams.has('page') ? parseInt(queryParams.get('page')) : 1;
        let content = [];
        // logic for start and finish numbers
        if (props.total > showPages) {
            finish = props.page <= showPages ? showPages : (props.page + eitherSide < props.total-eitherSide ? props.page + eitherSide : props.total);
            start = finish - showPages+1;
        }

        // logic for additional jumps
        if (start !== 1) {
            content.push(<li key="1" onClick={() => props.gotoPage(1)}>1</li>);
            content.push(<li key="0" className="inactive">...</li>)
        }
        for (let i = start; i < finish+1; i++) {
            content.push(<li key={i} className={ i === props.page ? 'active' : '' } onClick={() => props.gotoPage(i)}>{i}</li>)
        }
        if (finish < props.total-1) {
            content.push(<li key={props.total+1} className="inactive">...</li>)
            content.push(<li key={props.total} onClick={() => props.gotoPage(props.total)}>{props.total}</li>);
        }
        return content;
    };

    return (
        <>
            <table {...getTableProps()} className="database-table database-table--striped database-table--dynamic">
                <thead>
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()} className="proxima" >
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps()} className={column.only_desktop ? 'u-hidden-mobile' : ''} onClick={() => props.changeOrder(column.id)}>
                                {column.render('Header')}
                                {column.id === props.orderBy
                                    ? props.orderASC
                                        ? sortedAsc
                                        : sortedDesc
                                    : sortedOff}
                            </th>
                        ))}
                    </tr>
                ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                {page.map((row, index) => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                return (
                                    <td {...cell.getCellProps()} className={cell.column.only_desktop ? 'u-hidden-mobile' : ''}>
                                        {cell.render('Cell')}
                                    </td>
                                )
                            })}
                        </tr>
                    )
                })}
                </tbody>
            </table>
            <div className="datatable-paging proxima">
                <button onClick={() => props.gotoPage(props.page-1)} disabled={props.page==1} className="datatable-paging__prev">Prev<span className="u-hidden-mobile">ious Page</span></button>
                <ul className="datatable-paging__jump">
                    {getPagination()}
                </ul>
                <button onClick={() => props.gotoPage(props.page+1)} disabled={props.page==props.total} className="datatable-paging__next">Next<span className="u-hidden-mobile"> Page</span></button>
            </div>
        </>
    )
}